import { createSelector, Selector } from '@reduxjs/toolkit';
import { selectShared } from '../sharedSelectors';
import { tSharedAppState, tSharedStore } from '../types';

const selectMemberStore: Selector<tSharedAppState, tSharedStore['member']> =
  createSelector([selectShared], (shared) => shared.member);

const selectMemberHomePage: Selector<
  tSharedAppState,
  tSharedStore['member']['homePage']
> = createSelector([selectMemberStore], (memberStore) => memberStore.homePage);

const selectMemberCoursePage: Selector<
  tSharedAppState,
  tSharedStore['member']['coursePage']
> = createSelector([selectMemberStore], (memberStore) => memberStore.coursePage);

const selectMemberCourseDetails: Selector<
  tSharedAppState,
  tSharedStore['member']['coursePage']['courseDetails']
> = createSelector([selectMemberCoursePage], (memberStore) => memberStore.courseDetails);

const selectAssignedCourses: Selector<
  tSharedAppState,
  tSharedStore['member']['homePage']['assignedCourses']
> = createSelector([selectMemberHomePage], (memberStore) => memberStore.assignedCourses);

const selectTeamMemberships: Selector<
  tSharedAppState,
  tSharedStore['member']['homePage']['teamMemberships']
> = createSelector([selectMemberHomePage], (memberStore) => memberStore.teamMemberships);

const selectCourseProgress: Selector<
  tSharedAppState,
  tSharedStore['member']['coursePage']['courseProgress']
> = createSelector([selectMemberCoursePage], (memberStore) => memberStore.courseProgress);

const selectMeetingsStore: Selector<
  tSharedAppState,
  tSharedStore['member']['meetingsPage']
> = createSelector([selectMemberStore], (memberStore) => memberStore.meetingsPage);

const selectMeetingStore: Selector<
  tSharedAppState,
  tSharedStore['member']['meetingItem']
> = createSelector([selectMemberStore], (memberStore) => memberStore.meetingItem);

const selectBoardsStore: Selector<tSharedAppState, tSharedStore['member']['boardsPage']> =
  createSelector([selectMemberStore], (memberStore) => memberStore.boardsPage);

const selectNewBoards: Selector<
  tSharedAppState,
  tSharedStore['member']['boardsPage']['boards']
> = createSelector([selectBoardsStore], (boardsStore) =>
  boardsStore.boards.filter(
    (board) => board.newBoard || (board.newMessagesCount || 0) > 0
  )
);

const selectLearningMaterials: Selector<
  tSharedAppState,
  tSharedStore['member']['learningMaterials']
> = createSelector([selectMemberStore], (memberStore) => memberStore.learningMaterials);

const selectTestsStore: Selector<tSharedAppState, tSharedStore['member']['testsPage']> =
  createSelector([selectMemberStore], (memberStore) => memberStore.testsPage);

const selectActivityStore: Selector<tSharedAppState, tSharedStore['member']['activity']> =
  createSelector([selectMemberStore], (memberStore) => memberStore.activity);

const selectMyProgressStore: Selector<
  tSharedAppState,
  tSharedStore['member']['myProgress']
> = createSelector([selectMemberStore], (memberStore) => memberStore.myProgress);

const selectRewardNotificationsStore: Selector<
  tSharedAppState,
  tSharedStore['member']['rewardNotifications']
> = createSelector([selectMemberStore], (memberStore) => memberStore.rewardNotifications);

const selectWeekCalendarStore: Selector<
  tSharedAppState,
  tSharedStore['member']['weekCalendar']
> = createSelector([selectMemberStore], (memberStore) => memberStore.weekCalendar);

const selectors = {
  selectMemberStore,
  selectMemberHomePage,
  selectMemberCoursePage,
  selectMemberCourseDetails,
  selectAssignedCourses,
  selectTeamMemberships,
  selectCourseProgress,
  selectMeetingsStore,
  selectMeetingStore,
  selectBoardsStore,
  selectNewBoards,
  selectLearningMaterials,
  selectTestsStore,
  selectActivityStore,
  selectMyProgressStore,
  selectRewardNotificationsStore,
  selectWeekCalendarStore
};

export default selectors;
